import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
import { Translate, ICrudGetAllAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntities } from './business-unit.reducer';
import { IBusinessUnit } from 'app/shared/model/business-unit.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IBusinessUnitProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {}

export const BusinessUnit = (props: IBusinessUnitProps) => {
  useEffect(() => {
    props.getEntities();
  }, []);

  const { businessUnitList, match, loading } = props;
  return (
    <div>
      <h2 id="business-unit-heading">
        <Translate contentKey="ordersManagementApp.businessUnit.home.title">Business Units</Translate>
        <Link to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
          <FontAwesomeIcon icon="plus" />
          &nbsp;
          <Translate contentKey="ordersManagementApp.businessUnit.home.createLabel">Create new Business Unit</Translate>
        </Link>
      </h2>
      <div className="table-responsive">
        {businessUnitList && businessUnitList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="global.field.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="ordersManagementApp.businessUnit.businessUnitName">Business Unit Name</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {businessUnitList.map((businessUnit, i) => (
                <tr key={`entity-${i}`}>
                  <td>
                    <Button tag={Link} to={`${match.url}/${businessUnit.id}`} color="link" size="sm">
                      {businessUnit.id}
                    </Button>
                  </td>
                  <td>{businessUnit.businessUnitName}</td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${businessUnit.id}`} color="info" size="sm">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${businessUnit.id}/edit`} color="primary" size="sm">
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${businessUnit.id}/delete`} color="danger" size="sm">
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="ordersManagementApp.businessUnit.home.notFound">No Business Units found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ businessUnit }: IRootState) => ({
  businessUnitList: businessUnit.entities,
  loading: businessUnit.loading
});

const mapDispatchToProps = {
  getEntities
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(BusinessUnit);
